module.exports = __webpack_public_path__ + "img/406-2ccc33.png";